var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t(
                        "apeironGwApp.opcionterminalSnp.form.descripcionOpcionTerminal"
                      ) + " *",
                    "label-for": "input-descripcion-opcion-terminal",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-descripcion-opcion-terminal",
                      placeholder: _vm.$t(
                        "apeironGwApp.opcionterminalSnp.form.descripcionOpcionTerminal"
                      ),
                      disabled: !_vm.esEscritura,
                      state:
                        !_vm.$v.opcionTerminalForm.descripcionOpcionTerminal
                          .$invalid,
                    },
                    model: {
                      value: _vm.opcionTerminalForm.descripcionOpcionTerminal,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.opcionTerminalForm,
                          "descripcionOpcionTerminal",
                          $$v
                        )
                      },
                      expression:
                        "opcionTerminalForm.descripcionOpcionTerminal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t("apeironGwApp.opcionterminalSnp.form.fechaAlta") +
                      " *",
                    "label-for": "input-fecha-alta",
                  },
                },
                [
                  _c("b-form-datepicker", {
                    attrs: {
                      id: "input-fecha-alta",
                      placeholder: _vm.$t(
                        "apeironGwApp.opcionterminalSnp.form.fechaAlta"
                      ),
                      disabled: !_vm.esEscritura,
                      state: !_vm.$v.opcionTerminalForm.fechaAlta.$invalid,
                      max: _vm.fechaHoy,
                    },
                    model: {
                      value: _vm.opcionTerminalForm.fechaAlta,
                      callback: function ($$v) {
                        _vm.$set(_vm.opcionTerminalForm, "fechaAlta", $$v)
                      },
                      expression: "opcionTerminalForm.fechaAlta",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label: _vm.$t(
                      "apeironGwApp.opcionterminalSnp.form.fechaBaja"
                    ),
                    "label-for": "input-fecha-baja",
                  },
                },
                [
                  _c("b-form-datepicker", {
                    attrs: {
                      id: "input-fecha-baja",
                      placeholder: _vm.$t(
                        "apeironGwApp.opcionterminalSnp.form.fechaBaja"
                      ),
                      disabled: !_vm.esEscritura,
                      state: !_vm.$v.opcionTerminalForm.fechaBaja.$invalid,
                      max: _vm.fechaHoy,
                    },
                    model: {
                      value: _vm.opcionTerminalForm.fechaBaja,
                      callback: function ($$v) {
                        _vm.$set(_vm.opcionTerminalForm, "fechaBaja", $$v)
                      },
                      expression: "opcionTerminalForm.fechaBaja",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t(
                        "apeironGwApp.opcionterminalSnp.form.institucionSede"
                      ) + " *",
                    "label-for": "input-sede",
                  },
                },
                [
                  _c("b-form-checkbox-group", {
                    attrs: {
                      id: "input-sedes",
                      options: _vm.instituciones,
                      disabled:
                        !_vm.esEscritura || _vm.instituciones.length < 2,
                      stacked: "",
                    },
                    model: {
                      value: _vm.opcionTerminalForm.instituciones,
                      callback: function ($$v) {
                        _vm.$set(_vm.opcionTerminalForm, "instituciones", $$v)
                      },
                      expression: "opcionTerminalForm.instituciones",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-alert",
                {
                  attrs: {
                    variant: "warning",
                    show: _vm.instituciones.length < 1,
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.opcionterminalSnp.mensajes.seleccionarPrograma"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", [_c("b-col", [_c("hr")])], 1),
      _vm._v(" "),
      _vm.esEscritura
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticStyle: { "text-align": "end" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "button",
                        variant: "primary",
                        disabled: _vm.formularioIsInvalid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.guardarOpcionTerminal()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.opcionterminalSnp.acciones.add"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "add" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.limpiarDatos()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.opcionterminalSnp.acciones.limpiar"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "refresh" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }